import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { formatDateTime } from "../../../Helpers/Utils";
import ProfileAvatar from '../../../Assets/images/avatar.png';
import ListLayout from "../../../Components/List";
import Handler from "../../../Helpers/Handler"
import { CiMenuKebab } from 'react-icons/ci';
import { TbRosetteDiscountCheckFilled } from 'react-icons/tb';
import { MdAppRegistration } from 'react-icons/md';
import { LuCalendarDays } from 'react-icons/lu';
import { BsFillFuelPumpDieselFill } from 'react-icons/bs';
import { toast } from 'react-toastify';
import useListParams from "../../../Helpers/useListParams";

const List = () => {
    const navigate = useNavigate()
    const searchKeys = [{ key: "carId", value: "Car Id" }, { key: "brandName", value: "Brand" }, { key: "modelName", value: "Model" }, { key: "variantName", value: "Variant" }, { key: "segment", value: "Segment" }, { key: "registrationNo", value: "Reg No" }, { key: "year", value: "Year" }]
    const [download, setDownload] = useState(false)
    const [downloadSelect, setDownloadSelect] = useState([])
    const selection = [
        { key: "createdAt", value: "Created At" },
        { key: "createdId", value: "Created By" },
        { key: "carId", value: "Car ID" },
        { key: "ownerId", value: "Owner Id" },
        { key: "registrationNo", value: "Reg No" },
        { key: "variant", value: "Variant" },
        { key: "securityDeposit", value: "Security Deposit" },
        { key: "brand", value: "Brand" },
        { key: "model", value: "Model" },
        { key: "segment", value: "Segment" },
        { key: "year", value: "Year" },
        { key: "fuelType", value: "Fuel Type" },
        { key: "documents", value: "Documents" },
        { key: "transmissionType", value: "Transmission Type" },
        { key: "color", value: "Color" },
        { key: "features", value: "Features" },
        { key: "fasTag", value: "FasTag" },
        { key: "hub", value: "Hub" },
        { key: "deviceId", value: "Device Id" },
        { key: "odometer", value: "Odometer" },
        { key: "priceTypes", value: "Price Types" },
        { key: "star", value: "Star" },
        { key: "verified", value: "Verified" },
        { key: "verifiedBy", value: "Verified By" },
        { key: "status", value: "Status" },
    ]
    const initialFilters = {
        searchKey: "carId",
        transmissionType: "all",
        segment: "all",
        createdFrom: "",
        createdTo: "",
        count: 10,
        sortBy: "createdAt",
        sort: true,
        verified: "all",
        status: "all",
        search: "",
        seats: "all",
        fuelType: "all"
    };
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({ list: [], previous: false, next: false });
    // Page number in the URL path (/car/3), filters in the query string - see Helpers/useListParams.
    // (Filters used to live in localStorage, so they leaked into every later visit and new tabs.)
    const { page, setPage, filters, setFilter, resetFilters } = useListParams(initialFilters, { pathStyle: "segment" });

    const setPageNo = (value) => setPage(value);
    const setValue = (name, value) => setFilter(name, value);
    const resetFilter = () => resetFilters();
    const downloadData = async () => {
        if (!downloadSelect?.length) return toast.error("Please select any field to download")
        setLoading(true)
        const payload = {
            sort: filters?.sort,
            sortBy: filters?.sortBy,
            ...(filters?.search ? { search: filters?.search, searchKey: filters?.searchKey, } : {}),
            ...(filters.status !== undefined && filters?.status !== "all" ? { status: filters.status } : {}),
            ...(filters.verified !== undefined && filters?.verified !== "all" ? { verified: filters.verified } : {}),
            ...(filters.transmissionType !== undefined && filters?.transmissionType !== "all" ? { transmissionType: filters.transmissionType } : {}),
            ...(filters.fuelType !== undefined && filters?.fuelType !== "all" ? { fuelType: filters.fuelType } : {}),
            ...(filters.segment !== undefined && filters?.segment !== "all" ? { segment: filters.segment } : {}),
            ...(filters?.createdFrom ? { createdFrom: new Date(filters?.createdFrom) } : {}),
            ...(filters?.createdTo ? { createdTo: new Date(filters?.createdTo) } : {}),
            selection: downloadSelect?.map(element => element.key)
        };
        const response = await Handler({ method: 'POST', url: `/admin/download/car`, data: payload })
        if (response?.success) {
            toast.success(response.data?.message)
            setDownload(false)
        } else {
            toast.error(response?.data?.message)
        }
        setLoading(false)
    }
    const addList = () => {
        navigate("/car/register")
    }
    const fetchCars = useCallback(async () => {
        setLoading(true);
        try {
            const payload = {
                sort: filters?.sort,
                sortBy: filters?.sortBy,
                ...(filters?.search ? { search: filters?.search, searchKey: filters?.searchKey, } : {}),
                ...(filters.status !== undefined && filters?.status !== "all" ? { status: filters.status } : {}),
                ...(filters.verified !== undefined && filters?.verified !== "all" ? { verified: filters.verified } : {}),
                ...(filters.transmissionType !== undefined && filters?.transmissionType !== "all" ? { transmissionType: filters.transmissionType } : {}),
                ...(filters.fuelType !== undefined && filters?.fuelType !== "all" ? { fuelType: filters.fuelType } : {}),
                ...(filters.seats !== undefined && filters?.seats !== "all" ? { seats: filters.seats } : {}),
                ...(filters.segment !== undefined && filters?.segment !== "all" ? { segment: filters.segment } : {}),
                ...(filters?.createdFrom ? { createdFrom: new Date(filters?.createdFrom) } : {}),
                ...(filters?.createdTo ? { createdTo: new Date(filters?.createdTo) } : {})
            };
            const response = await Handler({ method: "post", url: `/admin/car/list/${page - 1}?count=${filters.count}`, data: payload })
            if (response?.success) {
                setData({ list: response?.data?.data?.list || [], previous: response?.data?.data?.previous || false, next: response?.data?.data?.next || false });
            } else {
                setData({ list: [], previous: false, next: false });
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }, [page, filters]);
    const filterItems = {
        sort: [{ key: "carId", name: "Car Id" }, { key: "createdAt", name: "Register Date" }, { key: "registrationNo", name: "Reg No" }],
        dropdown: [
            {
                key: "status",
                name: "Status",
                options: [{ key: "all", name: "All" }, { key: true, name: "Active" }, { key: false, name: "Inactive" }]
            },
            {
                key: "verified",
                name: "Verified",
                options: [{ key: "all", name: "All" }, { key: true, name: "Verified" }, { key: false, name: "Un Verified" }]
            },
            {
                key: "segment",
                name: "Segment",
                options: [
                    { key: "all", name: "All" },
                    { key: "Micro", name: "Micro" },
                    { key: "Hatchback", name: "Hatchback" },
                    { key: "Sedan", name: "Sedan" },
                    { key: "SUV", name: "SUV" },
                    { key: "MPV", name: "MPV" },
                    { key: "Coupe", name: "Coupe" },
                    { key: "Convertible", name: "Convertible" },
                    { key: "Roadster", name: "Roadster" },
                    { key: "Luxury", name: "Luxury" },
                    { key: "Crossover", name: "Crossover" },
                    { key: "Premium Hatchback", name: "Premium Hatchback" },
                    { key: "Premium Sedan", name: "Premium Sedan" },
                    { key: "Midsize SUV", name: "Midsize SUV" },
                    { key: "Compact SUV", name: "Compact SUV" },
                    { key: "Compact Sedan", name: "Compact Sedan" },
                    { key: "Executive Sedan", name: "Executive Sedan" },
                    { key: "Luxury SUV", name: "Luxury SUV" },
                    { key: "SedSports Sedanan", name: "Sports Sedan" },
                    { key: "Full-size SUV", name: "Full-size SUV" },
                ]
            },
            {
                key: "transmissionType",
                name: "Transmission Type",
                options: [{ key: "all", name: "All" }, { key: "Manual", name: "Manual" }, { key: "Automatic", name: "Automatic" }, { key: "Semi-Auto", name: "Semi-Auto" }]
            },
            {
                key: "fuelType",
                name: "Fuel Type",
                options: [{ key: "all", name: "All" }, { key: "Petrol", name: "Petrol" }, { key: "Diesel", name: "Diesel" }, { key: "CNG", name: "CNG" }, { key: "EV", name: "EV" }]
            },
            {
                key: "seats",
                name: "Seats",
                options: [{ key: "all", name: "All" }, { key: "2", name: "2" }, { key: "4", name: "4" }, { key: "5", name: "5" }, { key: "6", name: "6" }, { key: "7", name: "7" }, { key: "8", name: "8" }, { key: "9", name: "9" }]
            },
        ],
        daterangepicker: [
            {
                key: "created",
                name: "Created At",
                from: {
                    key: "createdFrom",
                    minEndDate: new Date(new Date()?.setHours(new Date()?.getHours() + 1))
                },
                to: {
                    key: "createdTo",
                    minStartDate: new Date(filters?.createdFrom),
                    minEndDate: new Date(new Date()?.setHours(new Date()?.getHours() + 1)),
                }
            }
        ]
    }
    const tableLayout = useMemo(() => [
        {
            key: "car",
            name: "Car",
            mandatory: true,
            render: (row) => (
                <div className="d-flex align-items-center gap-3">
                    <div className='d-flex'>
                        <img
                            src={row?.carImages?.length ? row.carImages[0] : ProfileAvatar}
                            alt={row.brand}
                            className="rounded-circle border"
                            width={40} height={40}
                            style={{ objectFit: 'cover' }}
                        />
                    </div>
                    <div className="d-flex flex-column">
                        <span className="fw-semibold text-dark text-capitalize">{(row.brand || "") + " " + (row.variantName || "")}</span>
                        <small className={`d-flex align-items-center gap-1 ${row.verified ? "text-success" : "text-muted"}`}>
                            {row.verified ? <i className="bi bi-patch-check-fill" /> : <i className="bi bi-x-circle" />}
                            {row.verified ? "Verified" : "Unverified"}
                        </small>
                    </div>
                </div>
            )
        },
        {
            key: "registrationNo",
            name: "Reg No",
            mandatory: true,
            render: (row) => (
                <div className="small">
                    <div className="text-dark">{row.registrationNo || ""}</div>
                    <div className="text-dark">{row.segment || ""}</div>
                </div>
            )
        },
        {
            key: "ownerId",
            name: "Owner",
            mandatory: true,
            render: (row) => (
                <div className="small">
                    <div className="text-dark">{row.ownerId === "GETMYDRIVE" ? "GETMYDRIVE" : "HOST" || ""}</div>
                </div>
            )
        },
        {
            key: "fuelTyoe",
            name: "Type",
            mandatory: true,
            render: (row) => (
                <div className="small">
                    <div className="text-dark">{row?.fuelType ? (Array.isArray(row?.fuelType) ? row?.fuelType?.join(", ") : row?.fuelType) : ""}</div>
                    <div className="text-dark">{row.transmissionType || ""}</div>
                </div>
            )
        },
        {
            key: "createdAt",
            name: "Register Date",
            render: (row) => <span className="text-muted small">{formatDateTime(row.createdAt)}</span>
        },
        {
            key: "status",
            name: "Status",
            render: (row) => {
                const isActive = row.status === true || row.isActive === true;

                return (
                    <span className={`badge rounded-pill ${isActive ? 'text-bg-success' : 'text-bg-danger'}`}>
                        <i className={`bi ${isActive ? 'bi-check-circle' : 'bi-x-circle'}`}></i>
                        {isActive ? "Active" : "Inactive"}
                    </span>
                );
            }
        }
    ], []);
    const gridLayout = useCallback((item) => (
        <div className="card rounded-4 hover-lift cursor-pointer" onClick={() => navigate(`/car/details/${item?.carId}`)}>
            <div className="card-body position-relative px-3">
                <div className='d-flex flex-column justify-content-center align-items-center my-1'>
                    <img src={item?.carImages?.length ? item?.carImages[0] : ProfileAvatar} className="rounded-circle" width={100} height={100} alt={item?.carId} />
                    <p className='d-flex align-items-center mb-1 text-capitalize' >{(item.brand || "") + " " + (item.variantName || "")} {item?.verified ? <TbRosetteDiscountCheckFilled className='ms-1 text-blue' /> : ""}</p>
                    <small className={`badge rounded-pill fw-light px-3 ${item?.status ? "text-success bg-success-subtle" : "text-danger bg-danger-subtle"} `}>
                        {item?.status ? "Active" : "Deactive"}
                    </small>
                </div>
                <div className='d-flex flex-column mt-3'>
                    <div className='d-flex gap-3 mb-2'>
                        <div>
                            <span className='d-flex rounded-circle fs-7 p-2 bg-primary-light'><MdAppRegistration className='p-0 m-1 text-primary' /></span>
                        </div>
                        <div className='d-flex flex-column'>
                            <span className='fw-normal fs-7' >Reg No </span>
                            {item?.registrationNo ? <small className={`fs-8 text-gray`}>{item?.registrationNo || "-"} </small> : <small className='fs-8'>-</small>}

                        </div>
                    </div>
                    <div className='d-flex gap-3'>
                        <div>
                            <span className='d-flex rounded-circle fs-7 p-2 bg-primary-light'><BsFillFuelPumpDieselFill className='p-0 m-1 text-primary' /></span>
                        </div>
                        <div className='d-flex flex-column'>
                            <span className='text-gray fw-normal fs-7' >Type </span>
                            <small className='fs-8 text-gray' >{(item?.transmissionType || "") + "-" + (item?.fuelType ? (Array.isArray(item?.fuelType) ? item?.fuelType?.join(", ") : item?.fuelType) : "") + "-" + (item?.segment || "")}</small>
                        </div>
                    </div>
                </div>
                <div className='d-flex gap-4 mt-4'>
                    <span className='text-gray d-flex align-items-center gap-1'><LuCalendarDays /> <span className='fs-8'>{item?.createdAt ? formatDateTime(item?.createdAt) : "-"}</span></span>
                    <span className='text-primary d-flex align-items-center gap-2'><span className='fs-8'>ID : {item?.carId}</span></span>
                </div>
            </div>
        </div>
    ), []);
    useEffect(() => {
        fetchCars();
    }, [fetchCars, filters]);
    return (
        <>
            <ListLayout
                page={page}
                setPageNo={setPageNo}
                title={"Car"}
                pageValue={"car"}
                loading={loading}
                data={data}
                table={tableLayout}
                onRowClick={(item) => navigate(`/car/details/${item?.carId}`)}
                grid={gridLayout}
                filterItems={filterItems}
                initialFilters={initialFilters}
                filters={filters}
                onFilterChange={setValue}
                resetFilter={resetFilter}
                download={() => { setDownloadSelect([]); setDownload(true) }}
                searchKeys={searchKeys}
                addList={addList}
            />
            {download && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Download Details</h5>
                                <button className="btn-close" onClick={() => setDownload(false)}></button>
                            </div>
                            <div className="modal-body px-5">
                                <div className='d-flex justify-content-between align-items-center'>
                                    <p className='text-muted'>Select Field...</p>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id='selectAll' onChange={(e) => { if (e.target?.checked) { setDownloadSelect(selection) } else { setDownloadSelect([]) } }} />
                                        <label className="form-check-label" htmlFor='selectAll'> Select All </label>
                                    </div>
                                </div>
                                <div className='row'>
                                    {
                                        selection?.map((element, key) => {
                                            return (
                                                <div className="form-check col-lg-4 my-2" key={key}>
                                                    <input className="form-check-input" type="checkbox" value={element.value} id={element.key} checked={downloadSelect?.length ? downloadSelect?.find(select => select?.key === element?.key)?.key : false} onChange={(e) => { if (e.target?.checked) { setDownloadSelect((prev) => ([...prev, element])) } else { setDownloadSelect(downloadSelect?.filter(selected => selected.key !== element.key)) } }} />
                                                    <label className="form-check-label" htmlFor={element.key}>{element.value}</label>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <div className="modal-footer align-items-center justify-content-center">
                                <button disabled={loading} className="btn btn-success" onClick={downloadData}>Download</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {download && <div className="modal-backdrop fade show"></div>}
        </>
    )
}

export default List
